// components/leads-clients/leads-clients.component.jsx
import React, { useState, useEffect } from "react";

import { useLocation, useNavigate } from "react-router-dom";

import { db, fieldValue } from "../../firebase/firebase.utils";

import Client from "./lead-client/lead-client.component";

// import Tooltip from "../retro/tooltip/tooltip.component";
import { Tooltip } from "react-tooltip";

import "./leads-clients.styles.scss";

import InlineAddBtn from "../InlineAddBtn";
import {
  TbTransform,
  TbBrandLinkedin,
  TbBrandFacebook,
  TbBrandInstagram,
  TbWorldWww,
  TbUserCheck,
  TbUserPlus,
  TbUserX,
  TbAffiliate,
} from "react-icons/tb";

import { FiSquare, FiCheckSquare } from "react-icons/fi";

const clientlibrary = [
  {
    name: "Bathe",
    id: "bathe",
    icon: "🛁",
  },
  {
    name: "Clean",
    id: "clean",
    icon: "🧹",
  },
  {
    name: "Skincare",
    id: "skincare",
    icon: "🧴",
  },
  {
    name: "Read",
    id: "read",
    icon: "📚",
  },
];

function normalizeClientType(value) {
  return String(value || "").toLowerCase() === "client" ? "Client" : "Lead";
}

export default function LeadsClients({
  currentUser,
  display,
  activeTab = "Lead",
}) {
  const [clients, setClients] = useState([]);
  const [clientIcon, setClientIcon] = useState("");
  const [clientName, setClientName] = useState("");
  const [clientPlatform, setClientPlatform] = useState("LinkedIn");
  const [clientEmail, setClientEmail] = useState("");
  const [clientPhone, setClientPhone] = useState("");
  const [referredBy, setReferredBy] = useState("");
  const [type, setType] = useState("Lead");
  const [clientSocialLink, setClientSocialLink] = useState("");
  const [clientWebLink, setClientWebLink] = useState("");
  const [clientNotes, setClientNotes] = useState("");
  const [clientProjects, setClientProjects] = useState([]);

  const [clientmodalMode, setClientModalMode] = useState("");
  const [showclientmodal, setShowClientModal] = useState(false);

  const [showAllClients, setShowAllClients] = useState(false);

  const [activeClient, setActiveClient] = useState("");

  // const [activeTab, setActiveTab] = useState("Lead");

  const [checkedToday, setCheckedToday] = useState(0);

  const history = useNavigate();
  const location = useLocation();
  const currentSpaceId = location.pathname.split("/")[2];

  let newDate = new Date();
  let date = ("0" + newDate.getDate()).slice(-2);
  let month = ("0" + (newDate.getMonth() + 1)).slice(-2);
  let year = newDate.getFullYear();

  const [selectedDate, setSelectedDate] = useState(`${year}-${month}-${date}`);

  useEffect(() => {
    if (!currentSpaceId) return;

    const unsubscribe = db
      .collection("space")
      .doc(currentSpaceId)
      .collection("clients")
      .onSnapshot((querySnapshot) => {
        const clientList = querySnapshot.docs.map((document) => {
          const data = document.data();

          return {
            ...data,
            id: document.id,
            type: normalizeClientType(data.type),
            history: Array.isArray(data.history) ? data.history : [],
            projects: Array.isArray(data.projects) ? data.projects : [],
          };
        });

        setClients(clientList);
      });

    return unsubscribe;
  }, [currentSpaceId]);

  const handleClientClick = (client) => {
    setClientModalMode("edit");
    setActiveClient(client);

    setClientIcon(client.icon || "");
    setClientName(client.name || "");
    setClientPlatform(client.platform || "LinkedIn");
    setClientEmail(client.email || "");
    setClientPhone(client.phone || "");
    setReferredBy(client.referredBy || "");
    setType(normalizeClientType(client.type));
    setClientSocialLink(client.socialLink || "");
    setClientWebLink(client.weblink || "");
    setClientNotes(client.notes || "");

    setClientProjects(Array.isArray(client.projects) ? client.projects : []);

    setShowClientModal(true);
  };

  const handleAddBtnClick = () => {
    setClientModalMode("add");
    setActiveClient(null);

    setClientIcon("");
    setClientName("");
    setClientPlatform("LinkedIn");
    setClientEmail("");
    setClientPhone("");
    setReferredBy("");
    setType(activeTab);
    setClientSocialLink("");
    setClientWebLink("");
    setClientNotes("");
    setClientProjects([]);

    setShowClientModal(true);
  };

  const handleSaveClient = async (event) => {
    event.preventDefault();

    if (!clientName.trim()) {
      window.alert("Please enter a client name.");
      return;
    }

    const clientData = {
      icon: clientIcon || "",
      email: clientEmail.trim(),
      name: clientName.trim(),
      notes: clientNotes.trim(),
      phone: clientPhone.trim(),
      platform: clientPlatform,
      projects: clientProjects,
      referredBy: referredBy.trim(),
      socialLink: clientSocialLink.trim(),
      type: normalizeClientType(type),
      weblink: clientWebLink.trim(),
      updatedAt: fieldValue.serverTimestamp(),
    };

    try {
      const clientsRef = db
        .collection("space")
        .doc(currentSpaceId)
        .collection("clients");

      if (clientmodalMode === "add") {
        await clientsRef.add({
          ...clientData,
          history: [
            {
              date: selectedDate,
              checked: 0,
            },
          ],
          archived: false,
          created: new Date(),
          createdBy: currentUser?.uid || null,
        });
      } else {
        await clientsRef.doc(activeClient.id).update(clientData);
      }

      setShowClientModal(false);
    } catch (error) {
      console.error("Client save error:", error);

      window.alert(error?.message || "The client could not be saved.");
    }
  };

  const handleConvertClient = (e) => {
    // e.preventDefault();
    if (activeClient.type === "Client") {
      db.collection("space")
        .doc(currentSpaceId)
        .collection("clients")
        .doc(activeClient.id)
        .update({
          type: "Lead",
        });
    } else if (activeClient.type === "Lead") {
      db.collection("space")
        .doc(currentSpaceId)
        .collection("clients")
        .doc(activeClient.id)
        .update({
          type: "Client",
        });
    }
  };

  const handleConvertClientFromList = (client) => {
    // e.preventDefault();
    if (client.type === "Client") {
      db.collection("space")
        .doc(currentSpaceId)
        .collection("clients")
        .doc(client.id)
        .update({
          type: "Lead",
        });
    } else if (client.type === "Lead") {
      db.collection("space")
        .doc(currentSpaceId)
        .collection("clients")
        .doc(client.id)
        .update({
          type: "Client",
        });
    }
  };

  const handleDeleteClient = (e) => {
    e.preventDefault();
    db.collection("space")
      .doc(currentSpaceId)
      .collection("clients")
      .doc(activeClient.id)
      .delete();
    setShowClientModal(false);
  };

  const handleCloseClient = () => {
    if (clientmodalMode === "add") {
      setShowClientModal(false);
      setClientName("");
      setClientIcon("");
    } else {
      setShowClientModal(false);
      setClientName("");
      setClientIcon("");
    }
  };

  function checkTodaysHistory(client) {
    const historyArray = Array.isArray(client.history) ? client.history : [];

    const historyItem = historyArray.find((item) => item.date === selectedDate);

    return historyItem?.checked ? <FiCheckSquare /> : <FiSquare />;
  }

  const handleCheckInClient = async (client) => {
    const historyArray = Array.isArray(client.history)
      ? [...client.history]
      : [];

    const existingIndex = historyArray.findIndex(
      (item) => item.date === selectedDate,
    );

    if (existingIndex === -1) {
      historyArray.push({
        date: selectedDate,
        checked: 1,
      });
    } else {
      historyArray[existingIndex] = {
        ...historyArray[existingIndex],
        checked: historyArray[existingIndex].checked ? 0 : 1,
      };
    }

    try {
      await db
        .collection("space")
        .doc(currentSpaceId)
        .collection("clients")
        .doc(client.id)
        .update({
          history: historyArray,
        });

      document
        .getElementById("client-check_tone")
        ?.play()
        .catch(() => {});
    } catch (error) {
      console.error("Client check-in error:", error);
    }
  };

  return (
    <div
      id="clients"
      style={{ display: display, flexDirection: "column", height: "100%" }}
    >
      <div className="clients">
        <div className="widgetbtns">
          <button className="client__today-btn">Archive</button>
        </div>
        <div className="clientcontent">
          {clients
            .filter((cl) => cl.type === activeTab)
            .map((client) => {
              const { name, type, id, platform } = client;
              return (
                <div key={id} className="clientline-main">
                  <div
                    onClick={() => handleClientClick(client)}
                    className="clientinfo"
                  >
                    <div className="client-progress-icon">
                      {platform === "LinkedIn" && <TbBrandLinkedin />}
                      {platform === "Facebook" && <TbBrandFacebook />}
                      {platform === "Instagram" && <TbBrandInstagram />}
                      {platform === "Web" && <TbWorldWww />}
                      {platform === "Client Referral" && <TbUserCheck />}
                      {platform === "Friend Referral" && <TbUserPlus />}
                      {platform === "Former Client" && <TbUserX />}
                      {platform === "Affiliate" && <TbAffiliate />}
                    </div>
                    <h5>{name}</h5>
                  </div>
                  <div className="client-lead-btngroup">
                    <div
                      className="client-lead-convert-btn"
                      onClick={() => handleConvertClientFromList(client)}
                      data-tooltip-id="client-convert-tooltip"
                      data-tooltip-content={
                        activeTab === "Lead"
                          ? "Convert to client"
                          : "Convert to lead"
                      }
                    >
                      <TbTransform />
                    </div>
                    <Tooltip id="client-convert-tooltip" />
                    <div
                      onClick={() => handleCheckInClient(client)}
                      className="client-checkbox"
                      data-tooltip-id="client-checkin-box"
                      data-tooltip-content={
                        activeTab === "Lead" ? "Check-in" : "Check-in"
                      }
                    >
                      {/* {checkedToday > 0 ? <FiCheckSquare /> : <FiSquare />} */}
                      {checkTodaysHistory(client)}
                    </div>
                    <Tooltip id="client-checkin-box" />
                  </div>
                </div>
              );
            })}
          <InlineAddBtn
            className="clientadd-btn"
            circleSize={28}
            iconSize={18}
            gap={5}
            fontSize="var(--inline-add-font-size)"
            onClick={handleAddBtnClick}
          >
            {activeTab === "Client" ? "Add client" : "Add lead"}
          </InlineAddBtn>
          <audio
            id="client-check_tone"
            src="/media/mixkit-pen-clicking-twice-2371.wav"
          />
        </div>
      </div>
      {showclientmodal && (
        <Client
          currentUser={currentUser}
          client={activeClient}
          clientIcon={clientIcon}
          setClientIcon={setClientIcon}
          clientName={clientName}
          setClientName={setClientName}
          handleCloseClient={handleCloseClient}
          handleSaveClient={handleSaveClient}
          handleDeleteClient={handleDeleteClient}
          clientmodalMode={clientmodalMode}
          clientPlatform={clientPlatform}
          setClientPlatform={setClientPlatform}
          clientProjects={clientProjects}
          setClientProjects={setClientProjects}
          clientEmail={clientEmail}
          setClientEmail={setClientEmail}
          clientPhone={clientPhone}
          setClientPhone={setClientPhone}
          referredBy={referredBy}
          setReferredBy={setReferredBy}
          type={type}
          setType={setType}
          clientSocialLink={clientSocialLink}
          setClientSocialLink={setClientSocialLink}
          clientWebLink={clientWebLink}
          setClientWebLink={setClientWebLink}
          clientNotes={clientNotes}
          setClientNotes={setClientNotes}
          activeTab={activeTab}
          handleConvertClient={handleConvertClient}
          currentSpaceId={currentSpaceId}
          setSelectedDate={setSelectedDate}
        />
      )}
    </div>
  );
}
